import { t } from "ttag";

import { useMediaQuery } from "@/shared/hooks";
import { PHONE_NUMBERS } from "@/shared/models";
import { DropdownMenu } from "@/shared/ui";
import { getFaqLink } from "@/shared/utils";
import { sidebarMenuVariants } from "../variants";
import { LinkItem } from "./link-item";

const { trigger, item, arrowIcon } = sidebarMenuVariants();

export const NeedHelpMenu = () => {
  const isMobile = useMediaQuery();

  const faqLink = getFaqLink();

  return (
    <DropdownMenu.Root modal={false}>
      <DropdownMenu.Trigger className={trigger()}>
        {t`Help`}
      </DropdownMenu.Trigger>
      <DropdownMenu.Content
        align={isMobile ? "start" : "end"}
        side={isMobile ? "top" : "right"}
        sideOffset={isMobile ? 0 : 12}
        alignOffset={isMobile ? -12 : 0}
      >
        <DropdownMenu.Item asChild className={item()}>
          <LinkItem link={faqLink} label={t`Check our FAQs`} />
        </DropdownMenu.Item>

        <DropdownMenu.Separator />

        <DropdownMenu.Item asChild className={item()}>
          <a href={PHONE_NUMBERS.MEDICAL_ISSUES.TEL_HREF} className="flex">
            <span className="text-neutral-950">{t`Medical issues`}</span>

            <span className="text-neutral-700">
              {PHONE_NUMBERS.MEDICAL_ISSUES.NUMBER}
            </span>
          </a>
        </DropdownMenu.Item>

        <DropdownMenu.Separator />

        <DropdownMenu.Item asChild className={item()}>
          <a href={PHONE_NUMBERS.CUSTOMER_SUPPORT.TEL_HREF} className="flex">
            <span className="text-neutral-950">{t`Customer support`}</span>

            <span className="text-neutral-700">
              {PHONE_NUMBERS.CUSTOMER_SUPPORT.NUMBER}
            </span>
          </a>
        </DropdownMenu.Item>

        <DropdownMenu.Arrow className={arrowIcon()} />
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
};
